class FeaturedCollectionsAccordion extends HTMLElement {
  constructor() {
    super();
    this.checkHeight = this.checkHeight.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.resizeTimeout = null;
  }

  connectedCallback() {
    this.checkHeight();
    
    window.addEventListener('resize', this.handleResize);
    
    this.addEventListener('load', this.checkHeight, true);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.removeEventListener('load', this.checkHeight, true);
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  handleResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    
    this.resizeTimeout = setTimeout(() => {
      this.checkHeight();
    }, 100);
  }

  checkHeight() {
    const viewportHeight = window.innerHeight;
    
    const accordionItem = this.querySelector('.featured-collections-accordion-item-wrapp');
    
    if (!accordionItem) {
      return;
    }

    let itemHeight = accordionItem.offsetHeight;
    
    const screenWidth = window.innerWidth;
    let additionalTop = 0;
    
    if (screenWidth >= 1600 && screenWidth <= 1700) {
      additionalTop = 10;
    } else if (screenWidth >= 1300 && screenWidth <= 1600) {
      additionalTop = 0;
    } else if (screenWidth >= 750) {
      additionalTop = 133;
    }
    
    itemHeight += additionalTop;
    
    if (viewportHeight > itemHeight - 100) {
      this.classList.add('accordion-sticky');
    } else {
      this.classList.remove('accordion-sticky');
    }
  }
}
customElements.define('featured-collections-accordion', FeaturedCollectionsAccordion); 